import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  internalIdList: any;
  internalloading: boolean;
  deviceinternalloading: boolean;
  addNewInternalLoading: boolean;
}

const initialState: InitialState = {
  internalIdList: [],
  internalloading: false,
  deviceinternalloading: false,
  addNewInternalLoading: false,
};

const internalIdsSlice = createSlice({
  name: "internalIds",
  initialState,
  reducers: {
    internalIdList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      internalIdList: action.payload,
    }),
    setInternalLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      internalloading: action.payload,
    }),
    addNewInternalLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      addNewInternalLoading: action.payload,
    }),
    setDeviceIdLinkWithInternalIdLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      deviceinternalloading: action.payload,
    }),
  },
});

export const { internalIdList, setInternalLoader, addNewInternalLoader, setDeviceIdLinkWithInternalIdLoader } = internalIdsSlice.actions;

export default internalIdsSlice.reducer;
